"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useQueryParamsHandler = void 0;
const QueryParamsContext_1 = require("./QueryParamsContext");
const getQueryParamValueFromUrl = (paramName) => {
    const query = new URLSearchParams(window.location.search);
    return query.get(paramName);
};
const deleteUrlQueryParam = (url, paramName) => url.searchParams.delete(paramName);
const setUrlQueryParam = (url, paramName, value) => url.searchParams.set(paramName, value);
const useQueryParamsHandler = () => {
    const { queryParamUpdate, setQueryParamUpdate } = (0, QueryParamsContext_1.useQueryParamsStore)();
    const updateQueryParam = (queryParam) => {
        if (!queryParam)
            return;
        const url = new URL(window.location.href);
        if (queryParam.clearOtherParams) {
            Array.from(url.searchParams.keys())
                .filter((k) => {
                if (queryParam.clearOtherParams === 'clear-all') {
                    return !queryParam.queryParamValues.some((qpValue) => qpValue.name === k);
                }
                else {
                    return (!queryParam.queryParamValues.some((qpValue) => qpValue.name === k) &&
                        !queryParam.clearOtherParams.some((qpName) => qpName === k));
                }
            })
                .forEach((k) => deleteUrlQueryParam(url, k));
        }
        queryParam.queryParamValues.forEach((queryParamValue) => {
            const value = queryParamValue.newValue;
            if (value) {
                setUrlQueryParam(url, queryParamValue.name, value);
            }
            else {
                deleteUrlQueryParam(url, queryParamValue.name);
            }
            if (queryParamValue.clearParam) {
                deleteUrlQueryParam(url, queryParamValue.name);
            }
            if (!queryParamValue.disableUrlUpdate) {
                window.history.pushState(null, '', url.toString());
            }
        });
        setQueryParamUpdate(Object.assign({}, queryParam));
    };
    const triggerAllQueryParamsFromUrl = () => {
        const search = new URLSearchParams(window.location.search);
        const queryParamValues = Array.from(search.keys()).map((paramName) => {
            return { name: paramName, disableUrlUpdate: true };
        });
        triggerQueryParamsUpdate([...queryParamValues]);
    };
    const triggerQueryParamUpdate = (queryParamValue, clearOtherParams) => {
        var _a;
        if (!queryParamValue.newValue && !queryParamValue.clearParam) {
            queryParamValue.newValue = (_a = getQueryParamValueFromUrl(queryParamValue.name)) !== null && _a !== void 0 ? _a : queryParamValue.fallbackValue;
        }
        let _queryParamUpdate = queryParamUpdate;
        if (!_queryParamUpdate) {
            _queryParamUpdate = {
                queryParamValues: [queryParamValue],
                clearOtherParams,
            };
        }
        else {
            if (!clearOtherParams) {
                const queryParamValueIndex = _queryParamUpdate.queryParamValues.findIndex((qp) => qp.name === queryParamValue.name);
                if (queryParamValueIndex > -1) {
                    _queryParamUpdate.queryParamValues[queryParamValueIndex] = queryParamValue;
                }
                else {
                    _queryParamUpdate.queryParamValues.push(queryParamValue);
                }
            }
            else {
                _queryParamUpdate.queryParamValues = [queryParamValue];
                _queryParamUpdate.clearOtherParams = clearOtherParams;
            }
        }
        updateQueryParam(Object.assign({}, _queryParamUpdate));
    };
    const triggerQueryParamsUpdate = (queryParamValues, clearOtherParams) => {
        queryParamValues.forEach((qpValue) => {
            var _a;
            if (!qpValue.newValue && !qpValue.clearParam) {
                qpValue.newValue = (_a = getQueryParamValueFromUrl(qpValue.name)) !== null && _a !== void 0 ? _a : qpValue.fallbackValue;
            }
        });
        let _queryParamUpdate = queryParamUpdate;
        if (!_queryParamUpdate) {
            _queryParamUpdate = {
                queryParamValues,
                clearOtherParams,
            };
        }
        else {
            if (!clearOtherParams) {
                queryParamValues.forEach((queryParamValue) => {
                    const queryParamValueIndex = _queryParamUpdate.queryParamValues.findIndex((qp) => qp.name === queryParamValue.name);
                    if (queryParamValueIndex > -1) {
                        _queryParamUpdate.queryParamValues[queryParamValueIndex] = queryParamValue;
                    }
                    else {
                        _queryParamUpdate.queryParamValues.push(queryParamValue);
                    }
                });
            }
            else {
                _queryParamUpdate.queryParamValues = queryParamValues;
                _queryParamUpdate.clearOtherParams = clearOtherParams;
            }
        }
        updateQueryParam(Object.assign({}, _queryParamUpdate));
    };
    const findQueryParamValue = (queryParamName) => queryParamUpdate === null || queryParamUpdate === void 0 ? void 0 : queryParamUpdate.queryParamValues.find((q) => q.name === queryParamName);
    return {
        triggerQueryParamUpdate,
        triggerQueryParamsUpdate,
        triggerAllQueryParamsFromUrl,
        getQueryParamValueFromUrl,
        findQueryParamValue,
        queryParamUpdate,
    };
};
exports.useQueryParamsHandler = useQueryParamsHandler;
